export default __webpack_public_path__ + "static/media/about-sec-img.da3efd5f.png";